import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import Footer from "../components/Footer";
import { ReactComponent as Logo } from "../assets/images/logos/logo-login.svg";
import { ACCESS_DENIED_MESSAGE } from "../utils/accessDenied";

const AccessDenied = () => {
  const { logout } = useAuth0();

  // The backend refused the login, so there is no app session to end here —
  // only the Auth0 one, which has to go or the next visit replays the same
  // rejected login.
  const handleLogout = () => {
    localStorage.clear();
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return (
    <>
      <div className={"login__wrapper access-denied__wrapper"}>
        <div className={"login__logo"}>
          <Logo />
        </div>
        <div className={"access-denied__card"}>
          <h5>Access denied</h5>
          <p className={"access-denied__message"}>{ACCESS_DENIED_MESSAGE}</p>
          <p className={"access-denied__hint"}>
            Your TriloDocs account is not authorised to use this application.
          </p>
          <div className={"access-denied__actions"}>
            <button
              onClick={handleLogout}
              className={"input-submit input-submit__primary"}>
              Logout
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AccessDenied;
